import { useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import "../../../library/common/DialogBox.scss";
import "../reportDashboard.scss";
import commonImages from "../../../assets";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": { padding: theme.spacing(2) },
  "& .MuiDialogActions-root": { padding: theme.spacing(1) },
}));

// Success counterpart to DialogBoxOk (library/common/DialogBoxOk.jsx), which hardcodes
// the delete icon for every caller. Reuses the same markup/classes off DialogBox.scss
// but swaps in commonImages.successCheck, since this is the only Ok-only dialog in the
// app that needs to read as a success confirmation rather than a destructive one.
const ShareLinkResultDialog = ({ type, url, clientName, onClose }) => {
  const [copied, setCopied] = useState(false);
  const isGenerated = type === "generated";

  const header = isGenerated ? "Share Link Created" : "Share Link Revoked";
  const body = isGenerated
    ? `A new public share link for ${clientName} is ready. Anyone with this link can view this client's safety dashboard without logging in.`
    : `The public share link for ${clientName} has been revoked. Anyone using the old link will no longer be able to open this dashboard.`;

  const handleCopy = () => {
    if (!url) return;
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="dialogBoxOver" data-testid="share-link-result-overlay">
      <BootstrapDialog
        onClose={onClose}
        aria-labelledby="share-link-result-title"
        open
        className="dialogBoxContainer"
        data-testid="share-link-result-dialog"
      >
        <img
          className="deleteIcon"
          src={commonImages?.successCheck}
          width="27"
          height="29"
          alt="success"
        />
        <DialogTitle id="share-link-result-title" className="dialog-title" sx={{ m: 0, p: 2 }}>
          {header}
        </DialogTitle>
        <DialogContent className="modalParaContent">
          <Typography gutterBottom className="modalPara">
            {body}
          </Typography>
          {isGenerated && url && (
            <Typography
              gutterBottom
              className="rdShareResult__url"
              data-testid="share-link-result-url"
            >
              {url}
            </Typography>
          )}
        </DialogContent>
        <DialogActions className="dialogConfirm">
          {isGenerated && url && (
            <Button onClick={handleCopy} data-testid="share-link-result-copy-btn">
              {copied ? "Copied!" : "Copy Link"}
            </Button>
          )}
          <Button
            autoFocus
            onClick={onClose}
            className="deleteno"
            data-testid="share-link-result-ok-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default ShareLinkResultDialog;
